import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ChartService {
  public chartData: any;

  constructor() { }

  setChartsData(data: any) {
    this.chartData = data;
  }

  setDummyChartData() {
    this.chartData = {
      id: 50,
      vocational_interests: {
        id: 1,
        technical: 0,
        investigator: 0,
        entrepreneur: 0,
        communicator: 0,
        analyst: 0,
      },
      multiple_intelligences: {
        id: 1,
        linguistic: 0,
        mathematical_logician: 0,
        space: 0,
        cinematic_bodily: 0,
        musical: 0,
        intrapersonal: 0,
        interpersonal: 0,
        naturalist: 0,
      },
      professional_fields: {
        id: 1,
        manual_technician: 0,
        research_scientist: 0,
        creative_artistic: 0,
        social_healthcare: 0,
        business_persuasive: 0,
        management: 0,
        virtual_digital_streamer: 0,
      },
      personalities: {
        id: 1,
        perfectionist: 0,
        altruistic: 0,
        active: 0,
        affective: 0,
        rational: 0,
        skeptical: 0,
        enthusiastic: 0,
        leader: 0,
        mediator: 0,
      },
      avks: {
        id: 1,
        auditory: 0.0,
        visual: 0.0,
        kinesthetic: 0.0,
      },
      learning_styles: {
        id: 1,
        active: 0,
        thoughtful: 0,
        theoretical: 0,
        pragmatic: 0,
      },
      intelligences: {
        id: 1,
        self_awareness: 0,
        empathy: 0,
        self_confidence: 0,
        motivation: 0,
        self_control: 0,
        social_skills: 0,
      },
      interest_options: {
        id: 1,
        technical_with_academic_option: 0.0,
        technical_inclination: 0.0,
      },
      competencies: {
        id: 1,
        self_study: 0.0,
        self_critical_capacity: 0.0,
        information_search: 0.0,
        time_organization: 0.0,
        social_skills: 0.0,
        project_management: 0.0,
        adaptability: 0.0,
        communication_skills: 0.0,
        information_treatment: 0.0,
        informatic_training: 0.0,
        it_level_used: 0.0,
      },
      psychometrics_personality: {
        id: 1,
        openness_to_experience: 0,
        conscientiousness: 0,
        extraversion: 0,
        agreeableness: 0,
        neuroticism: 0,
      },
      psychometrics_avk: {
        id: 1,
        visual_style: 0,
        auditory_style: 0,
        kinesthetic_style: 0,
      },
      psychometrics_emotional_regulation: {
        id: 1,
        emotional_acceptance: 0,
        goal_persistence: 0,
        impulse_control: 0,
        emotional_awareness: 0,
        emotional_clarity: 0,
        emotional_regulation_strategies: 0,
      },
      psychometrics_vocational_interests_self_efficacy: {
        id: 1,
        realistic: 0,
        investigative: 0,
        artistic: 0,
        social: 0,
        enterprising: 0,
        conventional: 0,
      },
      psychometrics_career_anchors: {
        id: 1,
        autonomy_independence: 0,
        entrepreneurial_creativity: 0,
        service_dedication: 0,
        pure_challenge: 0,
        lifestyle: 0,
        general_management: 0,
        security_stability: 0,
        technical_functional: 0,
      },
    };
  }

  getChartDataByCategory(category: any) {
    const chart_data = this.chartData[category];
    const array_data: unknown[] = [];
    if (chart_data) {
      const hasNested = Object.values(chart_data).some(
        (v) => typeof v === 'object' && v !== null && !Array.isArray(v)
      );
      if (hasNested) {
        const datasets: number[][] = [];

        for (const subValues of Object.values(chart_data)) {
          if (typeof subValues === 'object' && subValues !== null) {
            const data = Object.values(subValues) as number[];
            datasets.push(data);
          }
        }

        return datasets;
      } else {
        for (const [key, value] of Object.entries(chart_data)) {
          if (key !== 'id') array_data.push(value);
        }
        return array_data;
      }
    }

    return [];
  }
}
